var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUser?.id)?_c('InvocationsList',{attrs:{"user-id":_vm.currentUser.id}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }